import { faUser } from "@fortawesome/free-solid-svg-icons";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3TextInput from "../../core/et3-input/et3-text-input";
import getCoreLoginStore from "../../stores/core/core-login-store";

const UsernameFormItem = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, unitY } = theme;
  const { isSignInDisabled, username, setUserName, signIn } =
    getCoreLoginStore();
  const disabledEnter = isSignInDisabled.get();

  return (
    <Et3TextInput
      size="MEDIUM"
      withShadow={true}
      icon={faUser}
      label={i18n.get("USERNAME")}
      placeHolder={i18n.get("USERNAME")}
      type={"text"}
      value={username.get()}
      onChoose={(value: string) => setUserName(value)}
      onBlur={() => {}}
      style={{
        width: 280 * unitX,
        height: 95 * unitY
      }}
      onEnter={() => {
        if (!disabledEnter) {
          signIn();
        }
      }}
    />
  );
});
export default UsernameFormItem;
